module.exports = __webpack_public_path__ + "img/glogo237.afc10da5.png";